module.exports = __webpack_public_path__ + "assets/img/hospital.62803eeb.svg";